/** True when gateway env allows sandbox simulate (Giả lập TT). */
export function isPaymentGatewaySandboxEnv(environment?: string | null): boolean {
  const normalized = (environment || 'sandbox').trim().toLowerCase();
  return normalized === 'sandbox' || normalized === 'dev';
}
